module.exports = __webpack_public_path__ + "img/4-1.e2bd1b8f.svg";